
import ChatPage from "@/components/chat/ChatPage";

export default function Chat() {
  return <ChatPage />;
}
